import { SYMBOL_HYPHEN } from '../../../../../constants/common'
import { getMatchCriterionValueText } from '../../RentalPortalMatch.utils'

export function getMatchCriteriaPopoverRowValue({
  criterion,
  currency,
  isRequirement,
  t,
  value,
}) {
  return (
    getMatchCriterionValueText({
      criterion,
      currency,
      isRequirement,
      t,
      value,
    }) ?? SYMBOL_HYPHEN
  )
}
